<template>
    <div class="chat">
      <div class="page-header">
        <i class="back-icon" @click="$router.go(-1)"></i>
        <span>Chat</span>
        <Tool />
      </div>
      <div class="content">
        <template v-if="list.length">
          <!-- data-type=0 隐藏删除按钮 data-type=1 显示删除按钮   -->
          <div class="item" v-for="(item, index) in list" :key="item.characterId" data-type="0">
            <div class="item-box" @touchstart.capture="touchStart" @touchend.capture="touchEnd" @click="goChat(item.characterId)">
              <img :src="item.avatar" @error="setDefaultAvatar" class="avatar" alt="" />
              <div class="info">
                <p class="title">{{ item.characterName }}</p>
                <p class="message" >
                  <MarkdownItVue :content="item.msgType === 'selfie' ? '【Selfie Sent】' : item.content"></MarkdownItVue>
                </p>
              </div>
              <div class="time">{{ formatDate(item.chatTime)  }}</div>
            </div>
            <div class="del" @click="handleDelete(item.characterId)" :data-index="index">
            </div>
          </div>
        </template>
        <Empty v-else-if="loaded"/>
      </div>
    </div>
</template>
<script>
import defaultAvatarImage from '@/assets/images/icon/avatar.png';
import chatSession from '@/utils/chatSession';
import { formatDate } from '@/utils/index';
import MarkdownItVue from 'markdown-it-vue';
import Empty from '@/components/Empty.vue';
import Tool from '@/components/Tool';

export default {
  components: {
    MarkdownItVue,
    Tool,
    Empty,
  },
  data() {
    return {
      list: [],
      formatDate,
      startX: 0,
      endX: 0,
      loaded: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.list = chatSession.getChatList();
      this.loaded = true;
    },
    setDefaultAvatar(e) {
      e.target.src = defaultAvatarImage;
    },
    goChat(id) {
      if (this.checkSlide()) {
        this.restSlide();
      }
      if (!id) return;
      setTimeout(() => {
        this.$router.push(`/chatRoom/${id}`);
      }, 500);
    },
    // 滑动开始
    touchStart(e) {
      // 记录初始位置
      this.startX = e.touches[0].clientX;
    },
    // 滑动结束
    touchEnd(e) {
      // 当前滑动的父级元素
      const { parentElement } = e.currentTarget;
      // 记录结束位置
      this.endX = e.changedTouches[0].clientX;

      // 左滑
      if (parentElement.dataset.type === '0' && this.startX - this.endX > 30) {
        this.restSlide();
        parentElement.dataset.type = '1';
      }
      // 右滑
      if (parentElement.dataset.type === '1' && this.startX - this.endX < -30) {
        this.restSlide();
        parentElement.dataset.type = '0';
      }
      this.startX = 0;
      this.endX = 0;
    },
    // 判断当前是否有滑块处于滑动状态
    checkSlide() {
      const listItems = document.querySelectorAll('.item');
      for (let i = 0; i < listItems.length; i++) {
        if (listItems[i].dataset.type === '1') {
          return true;
        }
      }
      return false;
    },
    // 复位滑动状态
    restSlide() {
      const listItems = document.querySelectorAll('.item');
      // 复位
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].dataset.type = '0';
      }
    },
    handleDelete(id) {
      const loading = this.$loading();
      chatSession.removeChat(id);
      this.init();
      loading.close();
      this.$toast.success('operation successful!');
    },
  },
};
</script>
<style lang="less" scoped>
.chat {
  background-image: linear-gradient(#adf4cc 0%, #e4fce5 90px, #fff 200px);
  height: 100%;
  font-size: 16px;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    color: rgba(30, 30, 30, 1);
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
  }
  .content {
    padding: 16px 0;
    margin: 0 16px;
    height: 100%;
    overflow-x: hidden;
    .item {
      -webkit-transition: all 0.2s;
      transition: all 0.2s;
      .del {
        width: 83px;
        height: 68px;
        background: #ff4949;
        position: absolute;
        top: 0px;
        right: -68px;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        background: url('@/assets/images/icon/del.png') rgba(255, 92, 92, 1) 32px center no-repeat;
        background-size: 28px 28px;
      }
      &[data-type="0"] {
        transform: translate3d(0,0,0);
        .del {
          display: none;
        }
      }
      &[data-type="1"] {
        transform: translate3d(-83px, 0, 0);
      }
      // &::after {
      //   content: " ";
      //   position: absolute;
      //   left: 0.2rem;
      //   bottom: 0;
      //   right: 0;
      //   height: 1px;
      //   // border-bottom: 1px solid #ccc;
      //   color: #ccc;
      //   -webkit-transform-origin: 0 100%;
      //   transform-origin: 0 100%;
      //   -webkit-transform: scaleY(0.5);
      //   transform: scaleY(0.5);
      //   z-index: 2;
      // }
    }
    .item-box {
      border-radius: 16px;
      background: linear-gradient(130.84deg, #E6FAEE 18.93%, #E0F9F3 79.21%);
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      position: relative;
      z-index: 3;
      .avatar {
        width: 52px;
        height: 52px;
        border-radius: 52px;
      }
      .info {
        font-size: @fontSmall;
        width: 218px;
        .title {
          font-weight: 500;
          margin-bottom: 8px;
        }
        .message {
          color: rgba(117, 117, 117, 1);
          line-height: 14px;
          .overflow-ellipsis(2);
        }
      }
      .time {
        font-size: @fontSmall;
        align-self: flex-start;
        color: rgba(117, 117, 117, 1);
      }
    }
  }
}
</style>
